// Meta Pixel
export function initMetaPixel(pixelId: string) {
  if (typeof window === 'undefined') return
  if ((window as any).fbq) return

  const load = () => {
    const f = window as any
    const n = (f.fbq = function (...args: any[]) {
      if (n.callMethod) {
        n.callMethod.apply(n, args)
      } else {
        n.queue.push(args)
      }
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = [] as any[]

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    f.fbq('init', pixelId)
    f.fbq('track', 'PageView')

    // noscript fallback
    const noscript = document.createElement('noscript')
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
    noscript.appendChild(img)
    document.body.appendChild(noscript)
  }

  // Defer loading to avoid blocking main thread
  if ('requestIdleCallback' in window) {
    ;(window as any).requestIdleCallback(load, { timeout: 3000 })
  } else {
    setTimeout(load, 2000)
  }
}

// Google Analytics (gtag.js)
export function initGoogleAnalytics(measurementId: string) {
  if (typeof window === 'undefined') return
  if ((window as any).gtag) return

  const load = () => {
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
    document.head.appendChild(script)
    ;(window as any).dataLayer = (window as any).dataLayer || []
    function gtag(...args: any[]) {
      ;(window as any).dataLayer.push(args)
    }
    ;(window as any).gtag = gtag
    gtag('js', new Date())
    gtag('config', measurementId)
  }

  // Defer loading to avoid blocking main thread
  if ('requestIdleCallback' in window) {
    ;(window as any).requestIdleCallback(load, { timeout: 3000 })
  } else {
    setTimeout(load, 2000)
  }
}
